import styled from 'styled-components';
import {
  Autocomplete,
  TextField,
} from '@mui/material';

import colors from '../../../../../styles/colors';

const UserSelectWrapper = styled.div`
  width: 300px;
`;

const StyledAutoComplete = styled(Autocomplete)`
  .MuiAutocomplete-inputRoot {
    height: 56px;
  }
`;

const StyledTextField = styled(TextField)`
  background: ${colors.base.alpha};
`;

export {
  UserSelectWrapper,
  StyledAutoComplete,
  StyledTextField,
};
